<template>
  <b-row style="position: relative; min-height: 20vh" v-if="isReady">
    <b-col lg="6">
      <gmap-autocomplete
        :placeholder="placeholder"
        @place_changed="setPlace"
        class="form-control mb-5"
        
      >
      </gmap-autocomplete>
      <div
        class="alert alert-custom alert-default mb-0"
        role="alert"
        v-if="locationData.description"
      >
        <div class="alert-text">
          <div class="row align-items-center">
            <div class="col-auto">
              <a>
                <i class="ri-notification-fill ri-2x"></i>
              </a>
            </div>
            <div class="col-10">
              <p class="mb-0">
                <span>
                  {{ locationData.description }}
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>

      <form v-if="validations">
        <div class="select-location-wrapper">
          <p>
            Kota atau Kabupaten
            <span
              class="label-required"
              v-if="validations.province_id.includes('required')"
              >*</span
            >
          </p>
          <v-select
            v-model="locationData.city"
            :options="cityList"
            class="vs-style v-select-40"
            placeholder="Pilih Kota"
            @open="initialGetOption('city', 'cityList')"
            @search="
              (search, loading) =>
                searchDataOption(search, loading, 'province', 'provinceList')
            "
            :loading="selectLoading === 'city' || gmapLoading"
            @option:selected="onChangeCity"
          />
        </div>
        <div class="select-location-wrapper">
          <p>
            Kecamatan
            <span
              class="label-required"
              v-if="validations.city_id.includes('required')"
              >*</span
            >
          </p>
          <v-select
            v-model="locationData.district"
            :options="districtList"
            @option:selected="onChangeDistrict"
            class="vs-style v-select-40"
            placeholder="Pilih Kota"
            @open="initialGetOption('district', 'districtList')"
            @search="
              (search, loading) =>
                searchDataOption(search, loading, 'district', 'districtList')
            "
            :loading="selectLoading === 'district' || gmapLoading"
            :disabled="!locationData.city.value"
          />
        </div>
        <div class="select-location-wrapper">
          <p>
            Kelurahan
            <span
              class="label-required"
              v-if="validations.sub_district_id.includes('required')"
              >*</span
            >
          </p>
          <v-select
            v-model="locationData.sub_district"
            :options="subdistrictList"
            @option:selected="onChangeSubdistrict"
            class="vs-style v-select-40"
            placeholder="Pilih Kelurahan"
            @open="initialGetOption('sub-district', 'subdistrictList')"
            @search="
              (search, loading) =>
                searchDataOption(
                  search,
                  loading,
                  'sub-district',
                  'subdistrictList'
                )
            "
            :loading="selectLoading === 'sub-district' || gmapLoading"
            :disabled="!locationData.district.value"
          />
        </div>
      </form>
    </b-col>

    <b-col lg="6">
      <GmapMap
        ref="mapRef"
        :options="gmapOptions"
        :center="selectedCoordinate"
        :zoom="gmapZoom"
        :streetViewControl="false"
        style="height: 100%"
      >
        <Gmap-Marker
          :draggable="true"
          @dragend="onChangeMap"
          :position="selectedCoordinate"
        ></Gmap-Marker>
      </GmapMap>
    </b-col>
  </b-row>
</template>

<script>
import _ from "lodash";
export default {
  name: "location-form",
  props: {
    placeholder: {
      required: false,
      default: () => "Cari lokasi",
    },
    gmapOptions: {
      required: false,
      default: () => ({
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: true,
        streetViewControl: true,
        rotateControl: true,
        fullscreenControl: true,
        disableDefaultUi: false,
      }),
    },

    gmapZoom: {
      required: false,
      default: () => 10,
    },

    config: {
      type: Array,
      required: false,
      default: () => [
        {
          id: "province_id",
          validation: ["required"],
          api: "province",
          type: "location",
          label: "Provinsi",
        },

        {
          id: "city_id",
          validation: ["required"],
          api: "city",
          type: "location",
          label: "Kota atau Kabupaten",
        },

        {
          id: "district_id",
          validation: ["required"],
          api: "district",
          type: "location",
          label: "Kecamatan",
        },

        {
          id: "sub_district_id",
          validation: [],
          api: "sub-district",
          type: "location",
          label: "Kelurahan",
        },
      ],
    },

    value: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      placeSearch: '',
      tmpConfig: [],
      hasInitialize: false,
      validations: null,
      gmapLoading: false,
      gmapSearch: "",
      selectLoading: null,
      options: [],
      selectedCoordinate: {
        lat: -7.0245542,
        lng: 110.3470253,
      },

      locationData: {
        description: "",
        province: {
          value: null,
          label: "Pilih Provinsi",
        },
        city: {
          value: null,
          label: "Pilih Kota",
        },
        district: {
          value: null,
          label: "Pilih Kecamatan",
        },
        sub_district: {
          value: null,
          label: "Pilih Kelurahan",
        },
      },
      loading: false,
      cityList: [],
      districtList: [],
      subdistrictList: [],
      isReady: false,
    };
  },

  mounted() {
    this.setDefaultValue();
    this.setValidation();
  },

  // watch: {
  //   value(to) {
  //     if (!this.hasInitialize) {
  //       this.setDefaultValue()
  //     }

  //     const prevValue = {
  //       province_id 
  //     }
  //   }
  // },

  methods: {
    setDefaultValue() {
      let locationData = {
        description: this.value.address 
          ? this.value.address 
          : "",
        province: {
              label: this.value.province_name || this.value.province_id_name ? this.value.province_name || this.value.province_id_name :  "Pilih Provinsi",
              value: this.value.province_id || null,
            },
        city: {
              label: this.value.city_name || this.value.city_id_name ? this.value.city_name || this.value.city_id_name :  "Pilih Kota",
              value: this.value.city_id || null,
            },
            
        district: {
              label: this.value.district_name || this.value.district_id_name ? this.value.district_name || this.value.district_id_name :  "Pilih Kecamatan",
              value: this.value.district_id || null,
            },
            
            
        sub_district: {
              label: this.value.sub_district_name || this.value.sub_district_id_name ? this.value.sub_district_name || this.value.sub_district_id_name :  "Pilih Kelurahan",
              value: this.value.sub_district_id || null,
            },
      };

      this.placeSearch  = this.value.address || ''

      this.locationData = locationData;

        let coordinate = {
          lat: this.value && this.value.lat ? this.value.lat : -7.0245542,
          lng: this.value && this.value.lng ? this.value.lng :  110.3470253,
        }

        this.selectedCoordinate = coordinate
      this.isReady = true;

    },

    setValidation() {
      let tmpValidation = this.config;

      if (!tmpValidation.find((x) => x.id === "province_id")) {
        tmpValidation.push({
          id: "province_id",
          validation: ["required"],
        });
      }
      if (!tmpValidation.find((x) => x.id === "city_id")) {
        tmpValidation.push({
          id: "city_id",
          validation: ["required"],
        });
      }
      if (!tmpValidation.find((x) => x.id === "district_id")) {
        tmpValidation.push({
          id: "district_id",
          validation: ["required"],
        });
      }
      if (!tmpValidation.find((x) => x.id === "sub_district_id")) {
        tmpValidation.push({
          id: "sub_district_id",
          validation: [],
        });
      }

      let _validations = {};
      for (const c of tmpValidation) {
        if (c.id && Array.isArray(c.validation)) {
          _validations[c.id] = c.validation;
        }
      }

      // let tmpConfig = this.config
      // if (!tmpConfig.find(x => x.id === 'sub_district_id')) {
      //     tmpConfig.unshift(
      //         {
      //         id: "sub_district_id",
      //         validation: [],
      //         api: 'sub-district',
      //         type: 'location',
      //         label: 'Kelurahan'
      //         },
      //     )
      // }

      // if (!tmpConfig.find(x => x.id === 'district_id')) {
      //     tmpConfig.unshift(
      //         {
      //   id: "district_id",
      //   validation: ["required"],
      //   api: 'district',
      //   type: 'location',
      //   label: 'Kecamatan'
      // }
      //     )
      // }

      // if (!tmpConfig.find(x => x.id === 'city_id')) {
      //     tmpConfig.unshift(
      //         {
      //   id: "district_id",
      //   validation: ["required"],
      //   api: 'district',
      //   type: 'location',
      //   label: 'Kecamatan'
      // }
      //     )
      // }

      // {
      //   id: "city_id",
      //   validation: ["required"],
      //   api: 'city',
      //   type: 'location',
      //   label: 'Kota atau Kabupaten'
      // }

      this.validations = _validations;
    },
    onChangeCity(e) {
      if (e.value !== this.locationData.city.value) {
        this.locationData.province = {
          label: e.province_id,
          value: e.province_id_name,
        };

        this.locationData.district = {
          value: null,
          label: "Pilih Kecamatan",
        };
        this.locationData.sub_district = {
          value: null,
          label: "Pilih Kelurahan",
        };
        this.emitValue();
      }
    },

    onChangeDistrict(e) {
      if (e.value !== this.locationData.sub_district.value) {
        this.locationData.sub_district = {
          value: null,
          label: "Pilih Kelurahan",
        };
        this.emitValue();
      }

    },

    onChangeSubdistrict(e) {
      if (e.value !== this.locationData.sub_district.value) {
        this.locationData.sub_district = {
          value: e.value,
          label: e.label
        }
        this.emitValue
      }
    },

    emitValue() {
      let _tmpValue = {
          province_id: this.locationData.province.value,
          city_id: this.locationData.city.value,
          district_id: this.locationData.district.value,
          sub_district_id: this.locationData.sub_district.value,
          lat: this.selectedCoordinate.lat,
          lng: this.selectedCoordinate.lng,
          address: this.locationData.address 
      };

      if ('province_name' in this.value) {
        _tmpValue.province_name = this.locationData.province.label
      }
      if ('province_id_name' in this.value) {
        _tmpValue.province_name = this.locationData.province.label
      }
      if ('city_name' in this.value) {
        _tmpValue.city_name = this.locationData.city.label
      }
      if ('city_id_name' in this.value) {
        _tmpValue.city_name = this.locationData.city.label
      }
      if ('district_name' in this.value) {
        _tmpValue.district_name = this.locationData.district.label
      }
      if ('district_id_name' in this.value) {
        _tmpValue.district_name = this.locationData.district.label
      }
      if ('sub_district_name' in this.value) {
        _tmpValue.sub_district_name = this.locationData.sub_district.label
      }
      if ('sub_district_id_name' in this.value) {
        _tmpValue.sub_district_name = this.locationData.sub_district.label
      }

      let dataToEmit = Object.assign(this.value, _tmpValue);

      this.$emit("input", dataToEmit);
    },

    searchDataOption: _.debounce(function (search, loading, api, key) {
      if (loading instanceof Function) loading(true);
      let params = {
        search: search,
        limit: 10,
      };

      this.$_api
        .dataset(api, params)
        .then((res) => {
          if (loading instanceof Function) loading(false);
          for (const data of res.data.data) {
            data.label = data.name;
            data.value = data.id;
          }
          this[key] = res.data.data;
        })
        .catch((err) => {
          if (loading instanceof Function) loading(false);
          this.$_alert.error(err);
        });
    }, 600),

    initialGetOption(api, key) {
      this.selectLoading = api;

      let params = {
        limit: 10,
      };

      if (api === "district") {
        params.city_id = this.locationData.city.value;
      } else if (api === "sub-district") {
        params.district_id = this.locationData.district.value;
      } else {
      }
      this.$_api
        .dataset(api, params)
        .then((res) => {
          for (const data of res.data.data) {
            data.label = data.name;
            data.value = data.id;
          }
          this[key] = res.data.data;

          this.selectLoading = null;
        })
        .catch(() => {
          this.selectLoading = null;
        });
    },

    async onChangeMap(event, coordinate = null) {
      this.gmapLoading = false;
      this.selectedCoordinate = {
        lat: coordinate ? coordinate.lat : event.latLng.lat(),
        lng: coordinate ? coordinate.lng : event.latLng.lng(),
      };

      this.$set(this.selectedCoordinate, "lat", this.selectedCoordinate.lat);
      this.$set(this.selectedCoordinate, "lng", this.selectedCoordinate.lng);

      let geocodedMap = await this.$_sys
        .geocodeFromCoordinate(
          this.selectedCoordinate.lat,
          this.selectedCoordinate.lng
        )
        .catch((err) => {
          this.gmapLoading = false;
          this.$_alert.error(null, "Gagal", "Gagal mengambil alamat");
        });

      if (!geocodedMap.success) return;

      let syncLocation = await this.$_api
        .post("/helper/regional", {
          province_name: geocodedMap.result.country,
          city_name: geocodedMap.result.province,
          district_name: geocodedMap.result.district,
          sub_district_name: geocodedMap.result.subdistrict,
        })
        .catch((err) => {
          this.gmapLoading = false;
          this.$_alert.error(err);
        });

      if (!syncLocation.success) return;
      this.locationData = {
        description: geocodedMap.result.formatted_address,
        province: {
          value:
            syncLocation.data.province && syncLocation.data.province.id
              ? syncLocation.data.province.id
              : "",
          label:
            syncLocation.data.province && syncLocation.data.province.name
              ? syncLocation.data.province.name
              : "",
        },

        city: {
          value:
            syncLocation.data.city && syncLocation.data.city.id
              ? syncLocation.data.city.id
              : "",
          label:
            syncLocation.data.city && syncLocation.data.city.name
              ? syncLocation.data.city.name
              : "",
        },

        district: {
          value:
            syncLocation.data.district && syncLocation.data.district.id
              ? syncLocation.data.district.id
              : "",
          label:
            syncLocation.data.district && syncLocation.data.district.name
              ? syncLocation.data.district.name
              : "",
        },
        sub_district: {
          value:
            syncLocation.data.sub_district && syncLocation.data.sub_district.id
              ? syncLocation.data.sub_district.id
              : "",
          label:
            syncLocation.data.sub_district &&
            syncLocation.data.sub_district.name
              ? syncLocation.data.sub_district.name
              : "",
        },
      };


      this.gmapLoading = false;
      this.emitValue();
    },

    async setPlace(place) {
      this.onChangeMap(null, {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
      });
    },
  },
};
</script>

<style scoped>
.select-location-wrapper p {
  margin-bottom: 5px !important;
  margin-top: 8px;
}

.label-required {
  color: red;
}
</style>


// WEBPACK FOOTER //
// src/base/component/location-form-component.vue